import React from "react";
import PropTypes from "prop-types";
import HotTable from "react-handsontable";
import axios from "axios";
import Loading from "../general/Loading.js";
import LocationSelectNoAll from "../general/LocationSelectNoAll.js";

class PatronCountsImporter extends React.Component {
  state = {
    selectedLocationId: _.first(this.props.locations).id,
    loading: true,
    zones: [],
    patronCounts: [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ]
  };

  componentWillMount() {
    this.buildData();
  }

  buildData = () => {
    var that = this;

    axios({
      method: "get",
      url: "/zones.json?location_id=" + that.state.selectedLocationId,
      responseType: "json"
    }).then(function(response) {
      that.setState({ loading: false });
      that.setState({ zones: response.data });
    });
  };

  importPatronCounts = () => {
    var that = this;

    axios
      .post("/import_patron_counts", {
        patron_counts: that.state.patronCounts
      })
      .then(function(response) {
        var patronCounts = [
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {}
        ];

        that.setState({ patronCounts: patronCounts });

        toastr.success("Patron Counts Imported");
      })
      .catch(function(error) {
        toastr.error("Patron Counts not imported");
        console.log(error);
      });
  };

  addRows = () => {
    var rows = [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ];

    var patronCounts = this.state.patronCounts;
    this.setState({ patronCounts: patronCounts.concat(rows) });
    toastr.success("Rows added");
  };

  reset = () => {
    var patronCounts = [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ];

    this.setState({ patronCounts: patronCounts });
    toastr.success("Grid has been cleared");
  };

  newLocation(newLocation) {
    this.setState({ selectedLocationId: newLocation });
    this.buildData();
  }

  render() {
    var that = this;
    const width = { width: "1100px" };

    var colHeaders = ["Date *", "Time *"];

    var columns = [
      {
        data: "date",
        type: "date",
        dateFormat: "MM/DD/YYYY",
        correctFormat: true,
        allowEmpty: false
      },
      {
        data: "time",
        type: "time",
        correctFormat: true
      }
    ];

    var colWidths = [122, 122];

    _.forEach(this.state.zones, function(zone) {
      colHeaders.push(zone.name);

      columns.push({
        data: zone.id,
        type: "numeric"
      });

      colWidths.push(856 / that.state.zones.length);
    });

    return (
      <div style={width}>
        <h1>Patron Counts Importer</h1>
        <p>
          Copy and paste your patron count data from Excel to add them into
          DigiQuatics. Don't have an Excel file already? Download our template
          <a
            className="styled-link"
            href={
              "/download_excel_template.xlsx?template=patron_counts_importer&headers=" +
              colHeaders
            }
          >
            {" "}
            here{" "}
          </a>
          to get started.
        </p>
        <div className="row">
          <LocationSelectNoAll
            locationId={this.state.selectedLocationId}
            locations={this.props.locations}
            selectClassName="col-md-3 col-xs-12"
            newLocationCallback={newLocation => this.newLocation(newLocation)}
          />
          <div className="col-md-9 col-xs-12">
            <div className="pull-right">
              <button
                className="btn btn-pink btn-raised btn-long margin-right-five"
                onClick={() => that.importPatronCounts()}
              >
                IMPORT
              </button>
              <button
                className="btn btn-indigo btn-raised btn-long margin-right-five"
                onClick={() => that.addRows()}
              >
                ADD ROWS
              </button>
              <button
                className="btn btn-grey btn-raised btn-long"
                onClick={() => that.reset()}
              >
                RESET
              </button>
            </div>
          </div>
        </div>
        <br />
        {this.state.loading ? (
          <Loading loading={true} noDataMessage="" />
        ) : (
          <HotTable
            root="hot"
            data={this.state.patronCounts}
            colWidths={colWidths}
            colHeaders={colHeaders}
            columns={columns}
            afterRender={() => {
              const copyPasteElement = document.getElementById("HandsontableCopyPaste");
              if (copyPasteElement) {
                copyPasteElement.setAttribute("aria-label", "Paste Area for Handsontable");
              }
            }}
          />
        )}
      </div>
    );
  }
}

PatronCountsImporter.propTypes = {
  locations: PropTypes.array
};

export default PatronCountsImporter;
